import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`;

export const SearchBar = styled.div`
	padding: 10px;
	display: flex;
	color: ${Colors.darkBlue};
	border: 1px solid ${Colors.darkBlue};
	min-width: 650px;
	justify-content: center;
	gap: 30px;
	border-radius: 15px;
	margin-bottom: 30px;
	flex-direction: column;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
`;
